import React from "react";
import "./App.scss";
import Search from "./components/Search/Search";

function App() {
  return (
    <div className="app">
      <Search />
    </div>
  );
}

export default App;
